// --- 场馆管理 --- //

export default [
  {
    name: 'stadiumInfo',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/stadiumManagement/stadiumInfo',
    meta: { title: '场馆信息' },
    component: require('business/stadiumSystem/stadiumManagement/stadiumInfo/list.vue').default
  },
  {
    name: 'stadiumEdit',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/stadiumManagement/stadiumInfo/edit',
    meta: { title: '编辑场馆' },
    component: require('business/stadiumSystem/stadiumManagement/stadiumInfo/edit.vue').default
  },
  {
    name: 'stadiumDetail',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/stadiumManagement/stadiumInfo/detail',
    meta: { title: '场馆详情' },
    component: require('business/stadiumSystem/stadiumManagement/stadiumInfo/detail.vue').default
  },
  {
    name: 'ticketInfo',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId/stadiumManagement/ticketInfo',
    meta: { title: '票价信息' },
    component: require('business/stadiumSystem/stadiumManagement/ticketInfo/list.vue').default
  }
];
